import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-12 md:py-24 bg-cream" data-id="element-119">
      <div className="max-w-5xl mx-auto px-5 lg:px-8" data-id="element-120">
        <div className="grid md:grid-cols-12 gap-6 md:gap-12 items-center" data-id="element-121">
          <motion.div className="md:col-span-5 flex justify-center" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-122">
            <div className="relative w-40 h-40 md:w-64 md:h-64 rounded-full border-2 border-rosegold/20 flex items-center justify-center p-6 md:p-8" data-id="element-123">
              <div className="absolute inset-0 border border-rosegold/40 rounded-full animate-[spin_20s_linear_infinite]" data-id="element-124"></div>
              <svg className="w-16 h-16 md:w-24 md:h-24 text-rosegold" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-125">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-126" />
              </svg>
            </div>
          </motion.div>

          <motion.div className="md:col-span-7" initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} data-id="element-127">
            <h2 className="text-2xl md:text-4xl font-serif text-charcoal mb-4 md:mb-6" data-id="element-128">
              El error más común es creer que para recuperar tu figura necesitas
              hacer 100 abdominales diarios o salir a correr.
            </h2>
            <p className="text-lg md:text-xl text-rosegold font-medium mb-4 md:mb-6" data-id="element-129">
              La realidad es que esos ejercicios están destruyendo tu suelo
              pélvico.
            </p>
            <div className="space-y-3 md:space-y-4 text-charcoal/80 leading-relaxed" data-id="element-130">
              <p data-id="element-131">
                Cada abdominal tradicional empuja tus órganos hacia abajo,
                debilitando aún más tu musculatura íntima y abriendo el espacio
                de tu diástasis.
              </p>
              <p data-id="element-132">
                Es como intentar arreglar una pared agrietada golpeándola con un
                mazo. Si no cierras la "cremallera" interna de tu abdomen,
                ninguna dieta o faja hará que tu vientre vuelva a su lugar.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}